import React from 'react';
import PropTypes from 'prop-types';

const Underline = ({ color = 'currentColor', ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M5.313 3.136h-1.23V9.54c0 2.105 1.47 3.623 3.917 3.623s3.917-1.518 3.917-3.623V3.136h-1.23v6.323c0 1.49-.978 2.57-2.687 2.57s-2.687-1.08-2.687-2.57zM12.5 15h-9v-1h9z"/>
  </svg>
);

Underline.propTypes = {
  color: PropTypes.string,
};

export default Underline;
